import React from 'react'
import "../styles/annual-report.css"

export default function AnnualReport() {
  return (
    <></>
  )
}
